import { useRef, useState } from 'react';
import useUsersStore from 'store/users';
import { useNotificationsStore } from '@thermon-platforms/thermon-ui-core';
import { t } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { cloneDeep } from 'lodash';


function PersonalInformation({user}) {
  const tempUser = useRef();
  // NOTE - I'm not sure why but initial value for useRef
  // doesn't seem to be working with an object? Maybe it's
  // a life-cycle thing. Anyway, set it manually here.
  if (!tempUser.current) {
    tempUser.current = cloneDeep(user);
  }
  const [, notificationsStoreActions] = useNotificationsStore();
  const [, usersStoreActions] = useUsersStore();
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState();

  function updateUserInfo() {
    setLoading(true);
    // Fake request delay
    usersStoreActions.save(tempUser.current)
      .then(() => {
        // Notify the user we succeded
        notificationsStoreActions.notify(t`Personal information updated`, 'ok');
      })
      .catch(async res => {
        const newErrors = await res.json();
        setErrors(newErrors?.errors);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <form name="personal-information" key="personal-information">
      <ul>
        <li>
          <label htmlFor="fullName"><Trans>Name</Trans></label>
          <input
            type="text"
            id="fullName"
            name="fullName"
            className={errors?.fullName ? 'error' : ''}
            defaultValue={tempUser.current?.fullName}
            onChange={event => {
              tempUser.current.fullName = event.target.value;
              if (errors) {
                delete errors.fullName;
                setErrors({...errors});
              }
            }}
            disabled={user?.username == 'admin'}
          />
          {errors?.fullName ?
            <p className="error-text">{errors.fullName[0]}</p>
          : <></>}
        </li>
        <li>
          <label htmlFor="email"><Trans>Email</Trans></label>
          <input
            type="text"
            id="email"
            name="email"
            className={errors?.email ? 'error' : ''}
            defaultValue={tempUser.current?.email}
            onChange={event => {
              tempUser.current.email = event.target.value;
              if (errors) {
                delete errors.email;
                setErrors({...errors});
              }
            }}
          />
          {errors?.email ?
            <p className="error-text">{errors.email[0]}</p>
          : <></>}
        </li>
        <li>
          <label htmlFor="phone"><Trans>Phone</Trans></label>
          <input
            type="text"
            id="phone"
            name="phone"
            className={errors?.phoneNumber ? 'error' : ''}
            defaultValue={tempUser.current?.phoneNumber}
            onChange={event => {
              tempUser.current.phoneNumber = event.target.value;
              if (errors) {
                delete errors.phoneNumber;
                setErrors({...errors});
              }
            }}
          />
          {errors?.phoneNumber ?
            <p className="error-text">{errors.phoneNumber[0]}</p>
          : <></>}
        </li>
        <li>
          <button
            onClick={updateUserInfo}
            disabled={loading}
            className={loading ? 'processing' : ''}
          >
            <Trans>Update</Trans>
          </button>
        </li>
      </ul>
    </form>
  );
}

export default PersonalInformation;
